module.exports = __webpack_public_path__ + "static/media/joinYyGroup的副本.d0f7b9d0.jpg";